import React from "react";
import { AlertPopup } from './AlertPopup';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import Moment from 'moment';
import _subpopupissuereq from './Popupissuereqsub';
import axios from "axios";
import { genURL } from './../_getjson';
require("./../_css/PopUpOther.css");
export default class _popupissuereq extends React.Component {
    state = {
        type: this.props.type,
        col: [],
        rows: [],
        valueRetuen: "",
        Htext: "",
        SHtype: 3,
        dataRowselect: "",
        SELECTALLCLICK: 0,
        DOCNOSEND: "",
    }
    async componentDidMount() {
        var url
        switch (this.props.type) {
            case "popupissuereq":
                url = "CSSTKISSUEREQ/Mainpopup?USERCODE=" + this.props.USERCODE /* + "&DOCNO=" */;
                console.log("CSSTKISSUEREQ", genURL(url));
                var dataArray = [];
                await axios.get(genURL(url)).then(res => {
                    let data = res.data;
                    console.log(data);
                    for (let index = 0; index < data.length; index++) {
                        dataArray[index] = {
                            number: index + 1,
                            C0: 0,
                            C1: data[index].DOCNO,
                            C2: this.ReDate(data[index].DOCDATE),
                            C3: this.ReDate(data[index].DUEDATE),
                            C4: data[index].USERNAME,
                            C5: data[index].ISSUENAME,
                            C6: data[index].REMARK,
                            C7: data[index].ARNAME,
                            SITECODE: data[index].SITECODE,
                            ARCODE: data[index].ARCODE,
                            ISSUETYPE: data[index].ISSUETYPE,
                            DEPARTMENT: data[index].DEPARTMENT
                        }
                    }
                    //  console.log(this.state.rows);
                }).catch(e => {
                    //console.log("Err" + e);
                }).finally(_ => {
                    this.setState({ rows: dataArray });
                });

                break;
            default: break;
        }
        // setTimeout(() => {
        //     this.setState({ rows: this.state.col });
        // }, 100);
    }
    ReDate = (Date) => {
        let dataRe = ""
        if (Date) {
            dataRe = Moment(Date, 'YYYY-MM-DD').add(543, "year").format('DD/MM/YYYY')
        }
        return dataRe
    };
    _setPopup = (data) => {
        //console.log(data);
        switch (data) {
            case "subPopup":
                if (this.state.DOCNOSEND !== "") {
                    this.setState({ OtPopupType: data })
                    this.setState({ showSubpopup: !this.state.showSubpopup });
                } else {
                    AlertPopup("Error", "กรุณาเลือกข้อมูลที่ต้องการ");
                }
                break;
            default:
                break;
        }
    }
    onSelectRow = (data, col, id) => {
        //console.log(this.state.rows);

        if (col > 1) {
            var dataArray = this.state.rows;
            dataArray[id].C0 = 1;
            this.setState({ rows: dataArray });

            var docno_ = "";
            let colData = this.state.rows;
            for (let i = 0; i < colData.length; i++) {
                //console.log(colData[i].C0);
                if (colData[i].C0 === 1) {
                    if (i > 0) {
                        docno_ += "|"
                    }
                    docno_ += colData[i].C1;
                    this.setState({
                        ARCODE: colData[i].ARCODE,
                        ARNAME: colData[i].C7,
                        SITECODE: colData[i].SITECODE,
                        ISSUETYPE: colData[i].ISSUETYPE,
                        DEPARTMENT: colData[i].DEPARTMENT,
                        ISSUENAME: colData[i].C5,
                        REMARK: colData[i].C6
                    })
                }
            }
            this.setState({ DOCNOSEND: "Docno=" + docno_ });
            setTimeout(() => {
                if (this.state.rows[id].C0 === 1) {
                    this.setState({ OtPopupType: "subPopup" })
                    this.setState({ showSubpopup: !this.state.showSubpopup });
                } else {
                    AlertPopup("Error", "กรุณาเลือกข้อมูลที่ต้องการ");
                }
            }, 200);
        }
    }
    onChangeRadio = (e) => {
        this.setState({ SHtype: e.target.value });
    }
    cellcheckbox = (cell, row, enumObject, rowIndex) => {
        var btn = this.state.rows[rowIndex].C0;
        var btnShow = "";
        switch (btn) {
            case 0: btnShow = <span>
                <i class="far fa-square " onClick={this._updateStatus.bind(null, rowIndex, 1)}> </i>
            </span>;
                break;
            case 1: btnShow = <span>
                <i class="far fa-check-square" onClick={this._updateStatus.bind(null, rowIndex, 0)}>  </i>
            </span>;
                break;
            default: btnShow = <span><i class=""></i></span>;
        }
        return (<div>{btnShow}</div>)
    }
    _updateStatus = (rowIndex, val) => {
        if (rowIndex !== "selectAll") {
            let col = this.state.rows;
            col[rowIndex].C0 = val;
            this.setState({ rows: col });
        } else {
            this.setState({ SELECTALLCLICK: val })
            let colSA = this.state.rows;
            for (let i = 0; i < colSA.length; i++) {
                colSA[i].C0 = val;
            }
            this.setState({ rows: colSA });
        }
        setTimeout(() => {
            this._checkSelect();
        }, 30);
    }
    _checkSelect = () => {
        var docno_ = "";
        let colData = this.state.rows;
        for (let i = 0; i < colData.length; i++) {
            //console.log(colData[i].C0);
            if (colData[i].C0 === 1) {
                if (i > 0) {
                    docno_ += "|"
                }
                docno_ += colData[i].C1;
                this.setState({
                    ARCODE: colData[i].ARCODE,
                    ARNAME: colData[i].C7,
                    SITECODE: colData[i].SITECODE,
                    ISSUETYPE: colData[i].ISSUETYPE,
                    DEPARTMENT: colData[i].DEPARTMENT,
                    ISSUENAME: colData[i].C5,
                    REMARK: colData[i].C6
                })
            }
        }
        this.setState({ DOCNOSEND: "Docno=" + docno_ });
    }

    _popupClose = (data) => {
        switch (data) {
            case "closeSubpopup":
                this.setState({ showSubpopup: !this.state.showSubpopup });
                break;
        }
    }
    _getIteminPopup = (data) => {
        var department = this.state.DEPARTMENT
        /*  setTimeout(() => { */
        this.props.Get_popupissuereq(data, department)
        this.props.closePopup();
        /* }, 50); */
    }
    render() {
        const selectRowProp = {
            mode: 'checkbox',
            clickToSelect: true,
            onSelect: this.onRowSelect,
            onSelectAll: this.onSelectAll
        };
        return (
            <div className='popup'>
                {this.state.showSubpopup ? <_subpopupissuereq closePopup={this._popupClose.bind(null, "closeSubpopup")} type={this.state.OtPopupType}
                    Get_PopUpOther={this._getIteminPopup} usercreate={localStorage.getItem('Username')} datatable={this.state.DOCNOSEND} ARCODE={this.state.ARCODE}
                    ARNAME={this.state.ARNAME} SITECODE={this.state.SITECODE} ISSUETYPE={this.state.ISSUETYPE} DEPARTMENT={this.state.DEPARTMENT}
                    ISSUENAME={this.state.ISSUENAME} REMARK={this.state.REMARK} /> : null}
                <div class="PopUpOtherDivH" align="left">
                    <div class="PopUpOtherDivH1">
                        <i class="fas fa-search"> ค้นหาใบเบิกสินค้า </i>
                    </div>
                    <div class="PopUpOtherDivH2">
                        {/* <i class="fas fa-times" onClick={this.props.closePopup}></i> */}
                    </div>
                </div>
                <div className='popup_inner'>
                    {this.props.Data}
                    {/* <div class="PopUpOtherDivH" align="left">
                        <div class="PopUpOtherDivH1"><i class="fas fa-search" > {this.state.Htext} </i></div>
                        <div class="PopUpOtherDivH2"><i class="fas fa-times" onClick={this.props.closePopup}></i></div>
                    </div> */}
                    <div class="panel-body divTable" align="right">
                        <div style={{ marginTop: "10px" }} >
                            <BootstrapTable
                                data={this.state.rows}
                                options={{ onRowClick: this.onSelectRow, noDataText: "ไม่พบข้อมูลที่ค้นหา", }}
                                height="450"
                                hover condensed search>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataAlign="center" width="40" dataField='number' isKey> </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="30" dataField='C0' dataFormat={this.cellcheckbox.bind(this)}>
                                    <i class={this.state.SELECTALLCLICK === 0 ? "far fa-square" : "far fa-check-square"}
                                        onClick={this.state.SELECTALLCLICK === 0 ? this._updateStatus.bind(null, "selectAll", 1) : this._updateStatus.bind(null, "selectAll", 0)}>
                                    </i>
                                </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="190" dataField='C1'>ใบขอเบิก</TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="150" dataField='C2'> วันที่ขอเบิก </TableHeaderColumn>
                                {/* {this.state.showSH === true? */}
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="150" dataField='C3'> กำหนดคืน </TableHeaderColumn>
                                {/* :null} */}
                                {/* {this.state.showSH === true? */}
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="150" dataField='C4'> พนักงาน </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="280" dataField='C5'> ประเภท </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="150" dataField='C6'> หมายเหตุ </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="190" dataField='C7'> ลูกค้า </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="150" dataField='ARCODE'> ARCODE </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="150" dataField='DEPARTMENT'> DEPARTMENT </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="150" dataField='ISSUETYPE'> ISSUETYPE </TableHeaderColumn>
                                {/* :null} */}
                            </BootstrapTable>
                        </div>
                        <button class="PUSDbtn" onClick={this._setPopup.bind(null, "subPopup")}>
                            <i class="fas fa-check"> ตกลง </i>
                        </button>
                    </div>

                </div>
            </div>
        );
    }
}